(function () {
  'use strict';

  // Google Merchant Center Automated Discounts - Price Honoring v5.1
  // Fix: read price from data-product-price attribute (cents integer) not display text

  var GPV2 = {
    STORAGE_KEY: 'gpv2_session',
    STORAGE_TTL: 30 * 60 * 1000,
    WORKER_URL: 'https://kismile-gpv2.577987943zyc.workers.dev',

    init: function () {
      var token = this.getTokenFromURL();
      if (token) {
        var payload = this.decodeJWT(token);
        if (payload && payload.p && !this.isExpired(payload)) {
          var session = this.parsePayload(payload, token);
          this.storeSession(session);
          this.writeCartAttributes(session);
        }
      }
      this.applyDiscounts();
    },

    getTokenFromURL: function () {
      try { return new URLSearchParams(window.location.search).get('pv2') || null; }
      catch (e) { return null; }
    },

    decodeJWT: function (token) {
      try {
        var parts = token.split('.');
        if (parts.length < 2) return null;
        var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        var pad = b64.length % 4; if (pad) b64 += '==='.slice(0, 4 - pad);
        return JSON.parse(decodeURIComponent(
          atob(b64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join('')
        ));
      } catch (e) { return null; }
    },

    isExpired: function (p) {
      return p.exp && (Date.now() / 1000) > p.exp;
    },

    parsePayload: function (p, token) {
      var parts = (p.o || '').split('_');
      var productId = parts.length >= 3 ? parts[2] : null;
      var variantId = parts.length >= 4 ? parts[3] : null;
      return {
        token: token,
        discountedPrice: p.p,
        discountPct: Math.round(p.dp || 0),
        variantId: variantId,
        productId: productId,
        currency: p.c || 'USD',
        expires: Date.now() + this.STORAGE_TTL
      };
    },

    storeSession: function (data) {
      try { sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
    },

    loadSession: function () {
      try {
        var raw = sessionStorage.getItem(this.STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (Date.now() > data.expires) { sessionStorage.removeItem(this.STORAGE_KEY); return null; }
        return data;
      } catch (e) { return null; }
    },

    writeCartAttributes: function (s) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            gpv2_token: s.token,
            gpv2_price: String(s.discountedPrice),
            gpv2_pct: String(s.discountPct),
            gpv2_variant_id: s.variantId || ''
          }
        })
      }).catch(function () {});
    },

    // Get original price in cents from price element
    // Priority: data-product-price attr (Shopify stores cents here) > variant JSON > display text
    getOriginalCents: function (priceEl) {
      // 1. data-product-price attribute contains raw cents integer e.g. 29999
      var attrVal = priceEl.getAttribute('data-product-price');
      if (attrVal) {
        var parsed = parseInt(attrVal, 10);
        if (!isNaN(parsed) && parsed > 0) return parsed;
      }

      // 2. Look for variant JSON in page
      var variantJson = document.querySelector('[data-product-json]') ||
                        document.querySelector('[data-product]') ||
                        document.getElementById('ProductJson-product-template');
      if (variantJson) {
        try {
          var productData = JSON.parse(variantJson.textContent);
          var variant = productData.variants && productData.variants[0];
          if (variant && variant.price) return parseInt(variant.price, 10);
        } catch(e) {}
      }

      // 3. Fallback: parse display text
      // Shopify format: '$299.99' -> 29999
      var text = (priceEl.querySelector('[aria-hidden="true"]') || priceEl).textContent.trim();
      var clean = text.replace(/[^0-9.]/g, '');
      if (clean.indexOf('.') !== -1) {
        // Has decimal: '$299.99' format
        return Math.round(parseFloat(clean) * 100);
      } else {
        // No decimal: raw cents '29999' format
        return parseInt(clean, 10) || 0;
      }
    },

    calcDiscountedCents: function (originalCents, pct) {
      return originalCents - Math.floor(originalCents * pct / 100);
    },

    formatMoney: function (cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    applyDiscounts: function () {
      var self = this;
      var session = this.loadSession();
      if (!session) return;
      this.applyProductPageDiscount(session);
      this.applyCartPageDiscount(session);
      ['variantChange', 'variant:change'].forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          if (e.detail && e.detail.variant) self.applyProductPageDiscountForVariant(session, e.detail.variant);
        });
      });
    },

    applyProductPageDiscount: function (session) {
      if (!document.querySelector('[data-product-price]')) return;
      var sel = document.querySelector('[data-product-select]');
      var variantId = sel ? sel.value : (session.variantId || null);
      this.applyProductPageDiscountForVariant(session, { id: variantId });
    },

    applyProductPageDiscountForVariant: function (session, variant) {
      if (!variant || !session.discountPct) return;
      if (session.variantId && variant.id && String(session.variantId) !== String(variant.id)) return;

      var priceEl = document.querySelector('[data-product-price]');
      if (!priceEl) return;

      // Save original state once
      if (!priceEl.hasAttribute('data-gpv2-applied')) {
        var origText = (priceEl.querySelector('[aria-hidden="true"]') || priceEl).textContent.trim();
        var origCents = this.getOriginalCents(priceEl);
        priceEl.setAttribute('data-gpv2-orig-cents', String(origCents));
        priceEl.setAttribute('data-gpv2-orig-text', origText);
        priceEl.setAttribute('data-gpv2-applied', '1');
      }

      var originalCents = parseInt(priceEl.getAttribute('data-gpv2-orig-cents'), 10);
      if (!originalCents) return;

      var discountedCents = this.calcDiscountedCents(originalCents, session.discountPct);
      var formatted = this.formatMoney(discountedCents);

      // Update price display
      var span = priceEl.querySelector('[aria-hidden="true"]');
      if (span) span.textContent = formatted; else priceEl.textContent = formatted;
      priceEl.classList.add('on-sale', 'gpv2-price');

      // Show compare-at price
      var cWrap = document.querySelector('[data-product-price-wrap]');
      var cEl = document.querySelector('[data-compare-price]');
      if (cWrap) cWrap.classList.remove('hide');
      if (cEl) {
        var cs = cEl.querySelector('[aria-hidden="true"]') || cEl;
        cs.textContent = priceEl.getAttribute('data-gpv2-orig-text');
      }

      this.updateSaveBadge(session.discountPct);
      this.injectGPV2Banner(formatted, session.discountPct);
    },

    updateSaveBadge: function (pct) {
      var el = document.querySelector('[data-save-price]');
      if (!el) return;
      el.textContent = 'Save ' + pct + '%';
      el.classList.remove('hide');
    },

    injectGPV2Banner: function (price, pct) {
      var existing = document.getElementById('gpv2-banner');
      if (existing) { var s = existing.querySelector('strong'); if (s) s.textContent = price; return; }
      var block = document.querySelector('.product-block--price');
      if (!block) return;
      var el = document.createElement('div');
      el.id = 'gpv2-banner';
      el.style.cssText = 'background:#e8f5e9;border:1px solid #34a853;border-radius:4px;padding:8px 12px;margin-top:10px;font-size:13px;color:#1e8e3e;display:flex;align-items:center;gap:8px;';
      el.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#34a853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '<span>Google exclusive price: <strong>' + price + '</strong>' + (pct ? ' (' + pct + '% off)' : '') + '</span>';
      block.appendChild(el);
    },

    applyCartPageDiscount: function (session) {
      var self = this;
      this.injectCartNotice(session);
      this.interceptCheckoutButtons(session);
      setTimeout(function () { self.interceptCheckoutButtons(session); }, 500);
      setTimeout(function () { self.interceptCheckoutButtons(session); }, 1500);
      setTimeout(function () { self.interceptCheckoutButtons(session); }, 3000);
      if (window.MutationObserver) {
        var observer = new MutationObserver(function () { self.interceptCheckoutButtons(session); });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    },

    interceptCheckoutButtons: function (session) {
      var self = this;
      var selector = [
        'button[name="checkout"]',
        'input[name="checkout"]',
        '.cart__checkout',
        '[data-checkout-submit]',
        'button[data-checkout]',
        '.cart-checkout-btn',
        '#CartPageForm button[type="submit"]',
        'form[action="/checkout"] button',
        'form[action="/checkout"] input[type="submit"]',
        'a[href="/checkout"]'
      ].join(', ');
      document.querySelectorAll(selector).forEach(function (btn) {
        if (btn.getAttribute('data-gpv2-hooked')) return;
        btn.setAttribute('data-gpv2-hooked', '1');
        btn.addEventListener('click', function (e) {
          var s = self.loadSession();
          if (!s) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.redirectToDiscountedCheckout(s, btn);
        }, true);
      });
    },

    redirectToDiscountedCheckout: function (session, btn) {
      var self = this;
      if (btn.tagName === 'INPUT') btn.value = 'Applying Google discount...';
      else btn.textContent = 'Applying Google discount...';
      btn.disabled = true;
      fetch(self.WORKER_URL + '/create-discount?token=' + encodeURIComponent(session.token) + '&t=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (data) {
          window.location.href = (data && data.checkout_url) ? data.checkout_url : '/checkout';
        })
        .catch(function () { window.location.href = '/checkout'; });
    },

    injectCartNotice: function (session) {
      if (document.getElementById('gpv2-cart-notice')) return;
      var target = document.querySelector('#CartPageForm')
        || document.querySelector('form[action="/cart"]')
        || document.querySelector('.cart-template')
        || document.querySelector('.cart__items')
        || document.querySelector('[data-cart-form]');
      if (!target) return;
      var pct = session ? session.discountPct : 0;
      var el = document.createElement('div');
      el.id = 'gpv2-cart-notice';
      el.style.cssText = 'background:#e8f5e9;border:1px solid #34a853;border-radius:6px;padding:12px 16px;margin-bottom:16px;font-size:14px;color:#1e8e3e;display:flex;align-items:center;gap:8px;';
      el.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#34a853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '<span><strong>Google exclusive ' + (pct ? pct + '% ' : '') + 'discount active.</strong> Will be automatically applied at checkout.</span>';
      target.insertBefore(el, target.firstChild);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { GPV2.init(); });
  else GPV2.init();
  window.GPV2 = GPV2;

})();
